import type { IMappingValidationIssue, IMappingValidationResult } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";

function isValidationIssue(value: unknown): value is IMappingValidationIssue {
    if (typeof value !== "object" || value === null) return false;
    const issue = value as IMappingValidationIssue;
    return typeof issue.code === "string" && typeof issue.message === "string";
}

function isIssueArray(value: unknown): value is IMappingValidationIssue[] {
    return Array.isArray(value) && value.every(isValidationIssue);
}

export function isMappingValidationResult(value: unknown): value is IMappingValidationResult {
    if (typeof value !== "object" || value === null) return false;

    const validation = value as IMappingValidationResult;
    return (
        typeof validation.isValid === "boolean" &&
        typeof validation.isExportReady === "boolean" &&
        typeof validation.checkedAtUtc === "string" &&
        isIssueArray(validation.errors) &&
        isIssueArray(validation.warnings)
    );
}

export function coerceMappingValidationResult(value: unknown): IMappingValidationResult | null {
    return isMappingValidationResult(value) ? value : null;
}
